import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Banner-main__video-modal abs"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "flex column al-center",
  "data-scroll": "",
  "data-scroll-speed": "2.3"
}
const _hoisted_6 = { class: "header-title luxury uppercase c-white wc-lg" }
const _hoisted_7 = { class: "rel" }
const _hoisted_8 = { class: "Banner-main__render rel" }
const _hoisted_9 = ["srcset"]
const _hoisted_10 = ["srcset"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "Banner-main__scroll--line abs" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bg-t-red" })
], -1)
const _hoisted_13 = { class: "Banner-main__scroll--ttl fira f-menu uppercase c-white" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "f-menu c-white uppercase bold" }

import func from "@/helpers/func";
import {useMenuStore} from "@/store/pinia/menu";
import {ref, onMounted, watch, computed, onUnmounted, nextTick} from "vue";
import type {Ref} from "vue";
import {handleResize} from "@/composables/resizeHandler";
import {useRoute, useRouter} from "vue-router";
import {lerpFn} from "@/composables/lerpFn";
import clearTimeoutHandler from "@/composables/clearTimeoutHandler";
import {keyIcon, burgerCloseIcon} from "@/components/UI/svgs";
import {MenuItem} from "@/store/ts/interfaces/state.interface";


export default /*#__PURE__*/_defineComponent({
  props: {
    contentData: {
        type: Object,
    }
},
  setup(__props) {

const props = __props



// STORE
const store = useMenuStore();
store.disableScrollStatus = true;
const hasScrolledValue = ref(0);

// ROUTE
const route = useRoute();
const router = useRouter();

// COMPOSABLES
const {windowWidth, windowHeight} = handleResize();

// REFS
const videoCloseTO = ref(null);
const mainImage: Ref<string> = ref("");
const projectData = ref(null);
const appHeight = ref(0);
const pageYoffset = ref(0);
const hasScrolled = ref(false);

const circleRad = ref(270);
const isVideoOpen = ref(false);
const circleMouseRF = ref(null)
const selectedCircle = ref(null)
const oldCoordX = ref(0);
const oldCoordY = ref(0);
const newCoordX = ref(0);
const newCoordY = ref(0);
const titleTopPos = ref(0);

// METHODS

const setNewDivCoords = (): void => {
    const r = 270;
    circleMouseRF.value = window.requestAnimationFrame(setNewDivCoords);
    oldCoordX.value = lerpFn(oldCoordX.value, newCoordX.value, 0.15);
    oldCoordY.value = lerpFn(oldCoordY.value, newCoordY.value, 0.15);
    if (!selectedCircle.value) return;
    selectedCircle.value.style.transform = `translate3d(${((oldCoordX.value - r) / 2) * 0.1
    }px, ${((oldCoordY.value - r) / 2) * 0.1}px, 0px)`;


}
setNewDivCoords();

const handleVideoClose = () => {
    document.querySelector<HTMLMediaElement>('.Banner-main__video-modal').classList.add('is-closing');
    videoCloseTO.value = window.setTimeout(() => {
        isVideoOpen.value = false;

    }, 1300);
}
const setData = () => {
    let item = props.contentData.data?.list?.[0]
    mainImage.value = item?.images?.[0]?.url;
    projectData.value = {
        ...item,
        mobile: item?.images?.[0]?.devices?.mobile,
        desktop: item?.images?.[0]?.devices?.desktop,
        tablet: item?.images?.[0]?.devices?.tablet,
        video_url: item?.video?.videoFile?.url
    };
}
const getpageYoffset = () => {
    const appParent = document.querySelector<HTMLElement>('#app');
    appHeight.value = document.querySelector<HTMLElement>('.page-wrapper')?.offsetHeight;
    pageYoffset.value = appParent.scrollTop;
}
const setTitleTopPos = async () => {
    await nextTick()
    const textHeight = document.querySelector('.Banner-main__default-overlay .header-title')?.getBoundingClientRect()?.height;
    let boxHeight = document.querySelector('.Banner-main')?.getBoundingClientRect()?.height
    titleTopPos.value = (boxHeight / 2) - (textHeight / 2) + 40;
}

// COMPUTED
const locoY = computed(() => store.locoScrollY)
const isDark = computed(() => store.isDark)
const header = computed(() => props.contentData?.conf?.header?.title)
const isAboutUs = computed(() => {
    return Object.values(route.params).includes("about-us");
})
const isSmallBanner = computed(() => {
    return props.contentData?.conf?.conf?.includes('small-banner')
})

const getApartmentsLink = computed(() => store.indx.menus.filter((m: MenuItem) => m.configs.includes('apartment-page')))

// MOUNTED
onMounted(() => {
    if (windowWidth.value >= 1440) {
        hasScrolledValue.value = 60;
    } else {
        hasScrolledValue.value = 40;

    }

    setData()
    setTitleTopPos()
    setTimeout(() => {
        circleMouseRF.value = window.requestAnimationFrame(setNewDivCoords);

        if (windowWidth.value <= 1199) {
            const appParent = document.querySelector('#app');
            appParent.addEventListener('scroll', getpageYoffset);
        }
    }, 900);

    setTimeout(() => {
        store.disableScrollStatus = false;

    }, 2000);
})

// UNMOUNTED

onUnmounted(() => {
    window.cancelAnimationFrame(circleMouseRF.value);
    if (windowWidth.value <= 1199) {
        const appParent = document.querySelector('#app');
        appParent.removeEventListener('scroll', getpageYoffset);
    }

})
watch(locoY, (ns) => {
    if (ns >= hasScrolledValue.value && !hasScrolled.value && windowWidth.value >= 1200) {
        hasScrolled.value = true;
    }
})
watch(isVideoOpen, async (ns) => {
    if (ns) {
        await nextTick();
        document.querySelector<HTMLMediaElement>('.Banner-main__video-modal video').play()
        // store.getComponentCursor(null, null)
        store.getComponentCursor(null, 'zoom-cancel')

    } else {
        store.getComponentCursor(null, 'play')
    }

})



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (isVideoOpen.value && projectData.value?.video_url && _unref(isAboutUs))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(windowWidth) <= 1199)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "lh-0 flex al-center j-center abs",
                  innerHTML: _unref(burgerCloseIcon),
                  onClick: handleVideoClose
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            _createElementVNode("video", {
              preload: "auto",
              controls: "",
              "data-scale-type": "1.5",
              onClick: _withModifiers(handleVideoClose, ["prevent"]),
              class: "pointer"
            }, [
              _createElementVNode("source", {
                src: projectData.value?.video_url,
                type: "video/mp4"
              }, null, 8, _hoisted_4)
            ], 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("section", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isVideoOpen.value = true)),
      class: _normalizeClass(["Banner-main rel ov-hidden", { 'ev-none': _unref(store).disableScrollStatus ,'small':_unref(isSmallBanner)}]),
      onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_unref(isAboutUs) && projectData.value?.video_url?_unref(store).getComponentCursor($event, 'play'):'')),
      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).getComponentCursor($event, _unref(store).cursorComponent)))
    }, [
      _createElementVNode("div", {
        class: "Banner-main__default-overlay abs flex al-center column",
        style: _normalizeStyle({ paddingTop: titleTopPos.value + 'px' })
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(projectData.value?.title), 1)
        ])
      ], 4),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("picture", null, [
            _createElementVNode("source", {
              media: "(max-width:767px)",
              srcset: projectData.value?.mobile
            }, null, 8, _hoisted_9),
            _createElementVNode("source", {
              media: "(max-width: 1199px)",
              srcset: projectData.value?.tablet
            }, null, 8, _hoisted_10),
            _createElementVNode("img", {
              src: projectData.value?.desktop
            }, null, 8, _hoisted_11)
          ])
        ])
      ]),
      (_unref(windowWidth) >= 1199)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "Banner-main__scroll flex abs",
            style: _normalizeStyle({ top: (_unref(store).locoScrollY + (_unref(windowHeight) - 250)) + 'px' })
          }, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(func).tr("Scroll")), 1)
          ], 4))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_unref(windowWidth) <= 1199)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: _unref(getApartmentsLink)[0]?.full_url,
              class: _normalizeClass([{ 'hide-select-apartments': pageYoffset.value >= appHeight.value - (_unref(windowHeight) + 400) }, "Banner-main__footer flex al-center j-center bg-burgundy"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "lh-0 mr-13",
                    innerHTML: _unref(keyIcon)
                  }, null, 8, _hoisted_15),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(func).tr('Select Apartments')), 1)
                ])
              ]),
              _: 1
            }, 8, ["to", "class"]))
          : _createCommentVNode("", true)
      ]))
    ], 34)
  ], 64))
}
}

})